import { nextTick, onBeforeUnmount, onMounted, reactive, ref, Ref } from 'vue';

/** 预览大图store */
export const elImageStore = reactive({
  items: [] as string[],
  index: 0,
});

/** 根据图片url预览大图 （element ui） */
export function openImagePreviewByUrl(url: string) {
  elImageStore.items = [url];
  elImageStore.index = 0;

  openEleImagesPreview();
}

export function closeElePreviewDialog() {
  const closeBtn = document.querySelector('.el-image-viewer__close') as HTMLDivElement;

  if (!closeBtn) return;

  closeBtn.click();
  resetPreviewStore();
}

export function resetPreviewStore() {
  elImageStore.items = [];
  elImageStore.index = 0;
}

function openEleImagesPreview() {
  nextTick(() => {
    setTimeout(() => {
      document
        .getElementById('sys-image-previewer')
        .querySelector('img')
        .click();
    }, 0);
  });
}

/** 图片预览 */
export default function useElementImgPreview(
  container: Ref<HTMLElement | null> | string,
  options?: { imgClass?: string },
) {
  const { imgClass = '' } = options || {};

  const timeout = ref<any>(0);
  const interval = ref<any>(0);

  function getAllImages(): NodeListOf<HTMLImageElement> | null {
    const wrapper = getContainer();

    if (!wrapper) return null;

    const selectAllFn =
      wrapper?.querySelectorAll
        ? wrapper?.querySelectorAll.bind(wrapper)
        // @ts-ignore
        : wrapper?.wrapRef?.querySelectorAll.bind(wrapper?.wrapRef);

    return selectAllFn(imgClass || 'img') as NodeListOf<HTMLImageElement> | null;
  }

  function triggerPreviewAction(e: MouseEvent) {
    const wrapper = getContainer();

    if (!wrapper) return;

    const target = e.target as HTMLElement;
    const src = target?.getAttribute('src') || '';

    if (!src) return;

    const imgs = getAllImages() || [];
    const imgUrls = Array.from(imgs).map((img) => img.getAttribute('src') || '');

    elImageStore.items = imgUrls;
    elImageStore.index = imgUrls.findIndex((url) => url === src);

    openEleImagesPreview();
  }

  function getContainer(): HTMLElement {
    if (typeof container === 'string') return document.querySelector(container);

    return container?.value;
  }

  function addEventHandler() {
    const imgs = getAllImages();

    if (imgs) {
      for (const img of imgs) {
        img.style.cursor = 'pointer';
        img.style.objectFit = 'contain';

        img.removeEventListener('click', triggerPreviewAction, false);
        img.addEventListener('click', triggerPreviewAction, false);
      }
    }
  }

  function removeEventHandler() {
    const imgs = getAllImages();

    if (imgs) {
      for (const img of imgs) {
        img.removeEventListener('click', triggerPreviewAction, false);
      }
    }
  }

  function clearTimeObj() {
    if (interval.value) clearInterval(interval.value);
    if (timeout.value) clearTimeout(timeout.value);

    interval.value = 0;
    timeout.value = 0;
  }

  onMounted(() => {
    addEventHandler();

    interval.value = setInterval(() => {
      addEventHandler();
    }, 300);

    timeout.value = setTimeout(() => {
      clearTimeObj();
    }, 5000);
  });

  onBeforeUnmount(() => {
    clearTimeObj();
    removeEventHandler();
  });
}
